const state = {
    isShow: false,
    message: null,
    timeout: 5000,
    color: 'green',
}

const getters = {
    toast(state) {
        return { ...state }
    },
}

const mutations = {
    setIsShow(state, isShow) {
        state.isShow = isShow
    },
    setMessage(state, message) {
        state.message = message
    },
    setType(state, type) {
        state.color = type === 'error' ? 'red' : 'green'
    },
}

const actions = {
    show({ commit }, payload) {
        commit('setIsShow', true)
        commit('setMessage', payload.message)
        commit('setType', payload.type ?? 'success')
    },
    success({ commit }, payload) {
        commit('setIsShow', true)
        commit('setMessage', payload.message)
        commit('setType', 'success')
    },
    error({ commit }, payload) {
        commit('setIsShow', true)
        commit('setMessage', payload.message)
        commit('setType', 'error')
    },
    close({ commit }) {
        commit('setIsShow', false)
    },
    hide({ commit }) {
        commit('setIsShow', false)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
